import React from "react";
import { bool, shape } from "prop-types";
import { connect } from "react-redux";

import Heading from "pages/_components/Heading";
import FormattedDate from "pages/_components/FormattedDate";
import FormattedAmount from "pages/_components/FormattedAmount";

import * as i18n from "util/i18n";
import {
    getMultipleTransferTicketDestinationCmfLabelText,
    isMasspaymentsCmfApiEnabled,
    isValidCvuNumeric,
    MULTIPLE_TRANSFER_VOUCHER_COELSA_ID_LABEL_I18N_KEY,
} from "util/multipleTransfersCmf";

const FORM_ID = "multiple.transfers";

function renderValue(isDesktop, key, item) {
    if (key.includes("date")) {
        return <FormattedDate date={item} dateFormat="dd/MM/yyyy hh:mm:ss" showTime />;
    }
    if (key.includes("amount")) {
        return <FormattedAmount {...item} notBold className={`${isDesktop ? "f-size-4" : "f-size-65"}`} />;
    }
    return item;
}

function MultipleTransferIndividualTicketData({ isDesktop, data }) {
    const cmf = isMasspaymentsCmfApiEnabled();
    const cbuForType = data.cbuDestination != null ? String(data.cbuDestination).trim() : "";

    const rows = Object.entries(data).filter(([key, item]) => {
        if (!cmf) {
            return true;
        }
        if (key === "bankName" || key === "holder" || key === "voucherNumber") {
            const v = item == null ? "" : String(item).trim();
            return v !== "";
        }
        return true;
    });

    return (
        <div className="transfer-multiple__ticket mt-3">
            {rows.map(([key, item]) => {
                const labelKey =
                    cmf && key === "voucherNumber"
                        ? MULTIPLE_TRANSFER_VOUCHER_COELSA_ID_LABEL_I18N_KEY
                        : `${FORM_ID}.individual.data.${key}.label`;
                let displayLabel;
                if (cmf) {
                    if (key === "cbuDestination") {
                        displayLabel = getMultipleTransferTicketDestinationCmfLabelText();
                    } else if (key === "bankName" && isValidCvuNumeric(cbuForType)) {
                        displayLabel = i18n.get("multiple.transfers.entityDestination.label");
                    }
                }
                return (
                    <Heading.DataGroup
                        key={key}
                        containerClassName="transfer-data data-wrapper-flex"
                        label={labelKey}
                        displayLabel={displayLabel}
                        labelClassName="no-wrap"
                        data={renderValue(isDesktop, key, item)}
                        dataClassName="data-desc text-right"
                    />
                );
            })}
        </div>
    );
}

MultipleTransferIndividualTicketData.propTypes = {
    isDesktop: bool.isRequired,
    data: shape({}).isRequired,
};

export default connect()(MultipleTransferIndividualTicketData);
